export const SITE = {
  nameTa: 'தெய்வீக ஓசை',
  nameEn: 'Deiveega Oosai',
  taglineTa: 'தமிழ் பக்திப் பாடல்கள், ஸ்துதிகள் மற்றும் ஆன்மீக அறிவு',
  taglineEn: 'Tamil Devotional Songs, Stutis & Spiritual Knowledge',
  domain: 'deiveegaoosai.in',
  youtubeUrl: 'https://www.youtube.com/@DeiveegaOosai',
  youtubeSubscribeUrl: 'https://www.youtube.com/@DeiveegaOosai?sub_confirmation=1',
  logoMark: '/brand/logo-mark.jpg',
  logoFull: '/brand/logo-full.jpg',
  heroDesktop: '/brand/hero-text.jpg',
  heroMobile: '/brand/hero-mobile.jpg',
  ogImage: '/brand/og-share.jpg',
  email: 'contact@deiveegaoosai.in',
  usageNotice:
    'இலவசம் — தனிப்பட்ட பக்தி பயன்பாட்டிற்கும் வணிகமற்ற பகிர்விற்கும் மட்டும். வணிக மறுவிற்பனை, மாற்றம் அல்லது மறுபதிப்பு அனுமதிக்கப்படாது.',
} as const

export const CTA = {
  youtubeHero: 'YouTube-ல் பாடல்களைக் கேளுங்கள்',
  youtubeFull: 'YouTube-ல் முழுப் பாடலைக் கேளுங்கள்',
  youtubeShort: 'YouTube-ல் கேளுங்கள்',
  lyrics: 'வரிகள் & பொருள்',
} as const

/** Primary nav — Tamil only, one desktop row. Downloads live in the footer. */
export const NAV_ITEMS = [
  { path: '/', labelTa: 'முகப்பு' },
  { path: '/songs', labelTa: 'பக்திப் பாடல்கள்' },
  { path: '/stutis', labelTa: 'ஸ்துதிகள் & மந்திரங்கள்' },
  { path: '/lyrics', labelTa: 'வரிகள் & பொருள்' },
  { path: '/deities', labelTa: 'தெய்வங்கள்' },
  { path: '/deiveegam-theriyuma', labelTa: 'தெய்வீகம் தெரியுமா?' },
  { path: '/spiritual', labelTa: 'ஆன்மீக தகவல்கள்' },
] as const

export const FOOTER_LINKS = [
  { path: '/downloads', labelTa: 'இலவச பதிவிறக்கங்கள்', labelEn: 'Downloads' },
  { path: '/about', labelTa: 'எங்களைப் பற்றி', labelEn: 'About' },
  { path: '/contact', labelTa: 'தொடர்பு', labelEn: 'Contact' },
  { path: '/privacy', labelTa: 'தனியுரிமைக் கொள்கை', labelEn: 'Privacy' },
  { path: '/disclaimer', labelTa: 'பொறுப்புத்துறப்பு', labelEn: 'Disclaimer' },
  { path: '/terms', labelTa: 'பயன்பாட்டு விதிகள்', labelEn: 'Terms' },
  { path: '/copyright', labelTa: 'பதிப்புரிமை', labelEn: 'Copyright' },
] as const
